import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';
// services
import {UserService} from '../../service/user.service';
import {OrganizationService} from '../../service/organization.service';
// models
import {User} from '../../shared/models/user';
import {MessagingService} from '../../service/messaging.service';

@Component({
  selector: 'app-edit-admin',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})

export class CreateUserComponent implements OnInit, OnDestroy {
  protected user: User;
  private updateUserObserver;
  public organizations;
  public currentUser: User;
  public userEditForm: FormGroup;
  public updateUser;
  public titleObserver;
  public modalTitle;
  public formSubmitted = false;

  constructor(protected userService: UserService,
              private orgService: OrganizationService,
              public activeModal: NgbActiveModal,
              private msgService: MessagingService) {
  }

  ngOnInit() {


    this.currentUser = this.userService.currentUser;

    // live observables

    this.titleObserver = this.msgService.modalTitleSubject
      .subscribe((result) => {
        this.modalTitle = result;
      });

    this.updateUserObserver = this.userService.updatedUserSubject
      .subscribe((result) => {
        this.updateUser = result;
        if (!this.updateUser || this.updateUser === null || Object.keys(this.updateUser).length === 0) {
          this.updateUser = {
            name: null,
            email: null,
            mobile_number: null,
            country_code: '+44',
            organization_id: null,
            updatedAt: null
          };
        }
      });

    this.userEditForm = new FormGroup({
      'name': new FormControl(this.updateUser.name, Validators.required),
      'email': new FormControl(
        {
          value: this.updateUser.email,
          disabled: false
        },
        [
          Validators.required,
          Validators.email
        ]),
      'mobile_number': new FormControl(this.updateUser.mobile_number, [Validators.required, Validators.maxLength(11)]),
      'country_code': new FormControl(this.updateUser.country_code, Validators.required),
      'organization_id': new FormControl({
        value: this.updateUser.organization_title,
        disabled: false
      }, Validators.required)
    });

    // disable update user organization if user role is user
    if (this.updateUser.name === null && this.userService.currentUser.role !== 'user') {
      this.orgService.getOrganizations(null, 'modal')
        .subscribe((result) => {
          this.organizations = result;
        });
    } else {
      this.organizations = [{
        id: this.currentUser.organization_id,
        title: this.currentUser.organization_title
      }];
    }
  }

  updateUserThirdParty() {
    if (this.updateUser.name !== null && this.updateUser.name !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  updateDisableField() {
    if (Object.keys(this.updateUser).length !== 0 && this.updateUser.name !== null) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.userService.updatedUserSubject.next({});
  }

  onSubmit() {
    const form = this.userEditForm;

    const mobileNumber = form.value.mobile_number
      ? form.value.mobile_number.toString().replace(/^0/, '')
      : '';

    this.formSubmitted = true;

    this.user = {
      name: form.value.name,
      email: form.value.email,
      mobile_number: mobileNumber,
      country_code: form.value.country_code,
      organization_id: form.value.organization_id,
      updated_at: undefined
    };

    if (!this.updateUser.name) {
      this.userService.createUser(this.user, null, null)
        .subscribe((result) => {
          this.updateUser = result;
          this.activeModal.dismiss('Closed on successful submit');
        }, err => {
          this.formSubmitted = false;
        });
      this.formSubmitted = false;
    } else {
      this.userService.updateUser(this.user, null, this.updateUser.id)
        .subscribe((result) => {
          Object.assign(this.updateUser, result);
          if (this.updateUser.id === this.userService.currentUser.id) this.userService.currentUserSubject.next(this.updateUser);
          this.activeModal.dismiss('Closed on successful submit');
        }, err => {
          this.formSubmitted = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modal-edit/create-user/create-user.component.ts